function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-26.4%",
  y: "-233.3%",
  width: "152.8%",
  height: "566.5%",
  filterUnits: "objectBoundingBox",
  id: "ready_svg__b"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "4.66517857 0",
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-30.2%",
  y: "-278.6%",
  width: "160.4%",
  height: "657.2%",
  filterUnits: "objectBoundingBox",
  id: "ready_svg__e"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "4.11272321 0",
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.588 11.543C27.787 11.157 48 11.879 48 7.653 48 3.426 37.653 0 24.889 0 12.125 0 0 2.704 0 6.93c0 4.227 1.389 4.999 14.588 4.613z",
  id: "ready_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.532 9.543C24.645 9.543 34 9.313 34 6c0-3.314-7.387-6-16.5-6S.53 1.109.53 4.423c0 3.313 5.89 5.12 15.002 5.12z",
  id: "ready_svg__d"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(26 42)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ready_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ready_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.673 7C21.31 7 34 5.148 34 3.672 34 2.196 22.136 1 7.5 1S-19 2.196-19 3.672C-19 5.148-7.962 7 6.673 7z",
  fillOpacity: 0.277,
  fill: "#844C22",
  filter: "url(#ready_svg__b)",
  mask: "url(#ready_svg__c)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#8B572A",
  fill: "#F9D8A0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M34.476 24.992l17.43-3.288 3.046-.575v23.348L34.476 49z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#8B572A",
  fill: "#F9D8A0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M54.952 21.118l-19.964 4.14-19.964-4.117L34.988 17z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#8B572A",
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M34.55 25.202l-19.526-4.073v24.008L34.476 49z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.52 33.294l19.648 3.848a1 1 0 00.387 0l20.892-4.158v1.744l-20.883 4.5a1 1 0 01-.405.002l-19.64-3.896v-2.04z",
  fill: "#C31616",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.454 18.662L44 22.77a1 1 0 01.794.979V47.23l1.633-.358V22.938a1 1 0 00-.798-.98l-18.565-3.827-2.609.531z",
  fill: "#E72B2B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18 43)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ready_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ready_svg__d"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-2 9.429C9.046 9.429 18.846 8.105 18.846 7c0-1.105-9.8-2-20.846-2s-20 .895-20 2 8.954 2.429 20 2.429z",
  fillOpacity: 0.395,
  fill: "#844C22",
  filter: "url(#ready_svg__e)",
  mask: "url(#ready_svg__f)"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#8B572A",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20.816 28L15 49.244 27.44 51.8l4.4-2.24 5.02-19.086z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.183 34l-6.588-1.016M26.943 35.881L22 35.12"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M23.938 41.95l.65 1.95 3.963-3.67"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.165 40.216A3 3 0 1028 42.981"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEDED",
  d: "M27.579 51.788l.572-3.156 3.636.942z"
})));

function SvgReady(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgReady;